import { atom } from "recoil";

export const chatSettingsOpenState = atom<boolean>({
  key: "chatSettingsOpen",
  default: false,
});
